module.exports = __webpack_public_path__ + "static/media/turismo-centro.a6b614a4.svg";